import { render, staticRenderFns } from "./RadioIcon.vue?vue&type=template&id=3a7c5c4e&lang=pug&"
import script from "./RadioIcon.vue?vue&type=script&lang=ts&"
export * from "./RadioIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RadioIcon.vue"
export default component.exports